import { useFilterSplashScreenContext } from "./filter-splash-screen.context";

export function FilterSplashScreen() {
  const { dateFilterElement, clearFiltersElement } =
    useFilterSplashScreenContext();

  return (
    <div>
      <h2>Filters</h2>
      <p className="mb-4">
        Select the following filters you want to apply to the current table.
      </p>

      {dateFilterElement}
      {clearFiltersElement}
    </div>
  );
}